import { IActions, Context } from './actions.types';
import { Notification, INotification } from '@/entities';
export const actions: IActions = {

    setApplicationId(context: Context, id: number) {
        context.commit('setSelectedApplication', id);
    },

    setReviewId(context: Context, id: number) {
        context.commit('setSelectedReview', id);
    }

}